import React from 'react';

import {
    Button,
    ButtonGroupIcon,
    IconLayoutTopPanel2,
    IconChartPie,
    IconMusicFile,
} from '@trqk/components';
import { locale } from '@trqk/utils';

import { StatementSelector } from '../../../../menus';
import { ManageStatementsLink } from '../../../../nav';

import './statements-header-content.css';

const buttonGroupOptions = [
    {
        Icon: IconChartPie,
        value: 'charts',
    },
    {
        Icon: IconLayoutTopPanel2,
        value: 'table',
    },
];

interface StatementsHeaderContentProps {
    displayMode: StatementsHeaderDisplayMode;
    setDisplayMode(nextDisplayMode: StatementsHeaderDisplayMode): void;
    statementSelectionProps: StatementSelectionProps;
}

/**
 * Content for use in the LeftNavHeader for the Statements page. If `props.setDisplayMode` is
 * provided, also allows for switching between display modes for "charts" vs. "table."
 * @param props {StatementsHeaderContentProps}
 */
export const StatementsHeaderContent = ({
    displayMode,
    setDisplayMode,
    statementSelectionProps,
}: StatementsHeaderContentProps): JSX.Element => (
    <div className="flex flex-col items-start w-full 2xl:flex-row 2xl:justify-between 2xl:items-center 2xl-">
        <div className="flex items-center">
            <h3 className="mr-6">{locale.enUS.STATEMENTS.TITLE}</h3>
            <StatementSelector
                statementSelectionProps={statementSelectionProps}
            />
            <div className="ml-6">
                <ButtonGroupIcon
                    selectedValue={displayMode}
                    options={buttonGroupOptions}
                    handleChange={(
                        nextDisplayMode: StatementsHeaderDisplayMode,
                    ): void => {
                        setDisplayMode(nextDisplayMode);
                    }}
                />
            </div>
        </div>
        <div className="flex-grow w-full flex justify-start 2xl:justify-end mt-6 mb-2 2xl:mb-0 2xl:mt-0">
            <div className="manage-statements-button">
                <ManageStatementsLink>
                    <Button
                        addClasses="respond-to-mouse"
                        color="primary-light-bg"
                        padding="lg"
                        autoWidth={true}
                        boxShadow={true}
                        id="manage-statements-button"
                        dataCy="manage-statements-button-top"
                    >
                        <div className="flex justify-center items-center text-sm font-semibold mx-2">
                            <IconMusicFile
                                addClasses="mr-1"
                                fillColor="tertiary-200"
                            />
                            {
                                locale.enUS.STATEMENTS.HEADER.BUTTONS
                                    .MANAGE_STATEMENTS
                            }
                        </div>
                    </Button>
                </ManageStatementsLink>
            </div>
        </div>
    </div>
);
